const DEFAULT_FONT = '"Lato", sans-serif'
const DEFAULT_PRIMARY = '#0091ff'
const DEFAULT_PRIMARY_Contrast = '#ffffff'
const DEFAULT_SECONDARY = '#fff'
const DEFAULT_SECONDARY_Contrast = '#0091ff'

export const getDefaultStyles = () => ({
  fontFamily: DEFAULT_FONT,
  primaryColor: DEFAULT_PRIMARY,
  primaryContrastColor: DEFAULT_PRIMARY_Contrast,
  secondaryColor: DEFAULT_SECONDARY,
  secondaryContrastColor: DEFAULT_SECONDARY_Contrast,
})
